import { get } from "../../service/api";

const IBANCheck = async (accountNumber, bankCode) => {
  try {
    const response = await get(
      `/merchant/ibanCheck?accountNumber=${accountNumber}&bankCode=${bankCode}`
    );
    return response;
  } catch (error) {
    console.error("Error IBANCheck:", error);
    throw error;
  }
};

export default IBANCheck;
